import './styles.scss';
import { Button } from '@mui/material';

import ExchangeConnectImageSVG from '../../../assets/exchange-connect-image.svg';

interface IMessageInfo {
  message?: { title: string; description?: string };
}

export const MessageInfo = ({ message }: IMessageInfo) => {
  return (
    <div className="message-container">
      <span className="title">{message?.title}</span>
      <span className="description">{message?.description}</span>
    </div>
  );
};

interface IMessageError {
  message?: { title: string; description?: string };
  button?: { title: string; onClick?: () => void };
  icon?: React.ReactNode;
}

export const MessageError = ({ message, button, icon }: IMessageError) => {
  return (
    <div className="message-container">
      {icon || <img src={ExchangeConnectImageSVG} alt="crypto" />}

      <span className="title">{message?.title}</span>
      {message?.description && <span className="description">{message.description}</span>}
      {button?.onClick && (
        <Button className="connect-exchange-bt" onClick={button.onClick}>
          {button?.title || 'Button'}
        </Button>
      )}
    </div>
  );
};
